import { useI18n } from "@/lib/i18n";

/**
 * Slim colored strip at very top of the page — establishes a hard boundary
 * with the transparent nav below so the hero doesn't visually leak into the header.
 */
export default function AnnouncementBar() {
  const { lang } = useI18n();
  const items = lang === "nl"
    ? [
        "Gratis EU-verzending vanaf €200",
        "Voor 15:00 besteld = vandaag verzonden",
        "HPLC ≥ 99% zuiverheid",
        "Third-party geanalyseerd",
      ]
    : lang === "de"
    ? [
        "Kostenloser EU-Versand ab €200",
        "Bis 15:00 bestellt = heute versandt",
        "HPLC ≥ 99% Reinheit",
        "Von Drittanbietern analysiert",
      ]
    : [
        "Free EU shipping over €200",
        "Order by 3PM = ships today",
        "HPLC ≥ 99% purity",
        "Third-party analyzed",
      ];

  return (
    <div
      data-testid="announcement-bar"
      className="fixed top-0 left-0 right-0 z-[60] h-8 flex items-center overflow-hidden text-white"
      style={{
        background:
          "linear-gradient(90deg, #00529B 0%, #003a70 45%, #5A2A82 100%)",
      }}
    >
      <div className="whitespace-nowrap flex animate-[marquee_36s_linear_infinite]">
        {[...items, ...items, ...items].map((label, i) => (
          <span
            key={i}
            className="inline-flex items-center gap-4 px-8 font-mono-label text-[10px] tracking-[0.24em]"
          >
            <span
              className="inline-block w-1.5 h-1.5 rounded-full"
              style={{
                background:
                  ["#00E5B0", "#FFB800", "#FF3D5B", "#FFFFFF"][i % 4],
              }}
            />
            {label}
          </span>
        ))}
      </div>
    </div>
  );
}
